<script lang="ts" setup>
import { Statistics } from '@/models/statistics.model';
import statisticsService from '@/services/statistics.service';

import { onMounted, ref } from 'vue';

const data = ref<Statistics[]>([]);

onMounted(async () => {
  const d = await statisticsService.actionsAddedPerDay();
  data.value = d;
});
</script>
<template>
  <v-container>
    <h2>Actions</h2>
    <p>
      This shows the amount of actions added and completed in the past 30 days.
    </p>
    <v-frappe-chart
      type="bar"
      :labels="data.map((d) => d.label)"
      :data="[
        {
          name: data[0]?.stackedValues[0].label || '',
          values: data.map((d) => d.stackedValues[0].value),
        },
        {
          name: data[0]?.stackedValues[1].label || '',
          values: data.map((d) => d.stackedValues[1].value),
        },
      ]"
      :height="300"
      :colors="['red', 'orange']"
    />
  </v-container>
</template>
